import React, { useLayoutEffect } from "react";
import { useIntl } from "react-intl";
import type { FC } from 'react';
import AppRouter from "./routes/AppRouter";
import { Notifier } from "./modules/notistack/components/Notifier";
import { authService } from "./modules/auth";
import { registerInterceptors } from "./modules/http";

const App: FC = props => {
  const intl = useIntl();
  useLayoutEffect(() => {
    registerInterceptors(intl);

    if (authService.isAuth) {
      setInterval(() => {
        authService.refresh();
      }, 900000);
    } 
  }, []);

  return (
    <>
      <Notifier />
      <AppRouter />
    </>
  );
}

export default App;
